import { useEffect, useState, useContext } from "react";
import { UserContext } from "../../stores/Context/Context";
import { useSelector, useDispatch } from "react-redux";
import { contactInformationDetails } from "../../stores/slices/einSlice";
import style from "./Registration-style.module.css";
import { toast } from "react-toastify";
import Input from "../input/Input";
import PartnerForm from "./PartnerForm";
import { useNavigate } from "react-router-dom";
import { registerApi } from "../../stores/slices/registerSlice";
import Loader from "../menu/Loader";
import {
  resetregsuccess,
  privacyPolicycheckboxflag,
} from "../../stores/slices/registerSlice";
import { preAuth } from "../../stores/slices/preAuthSlice";
import { language } from "../../stores/slices/languageSlice";
import { PARTNER_AUTH, PARTNER_BROWSER_ID } from "../../constant/Constants";
const ContactInfo = () => {
  const selectedLanguage = useSelector(language).Registrations.ContactInfo;
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const registrationDetails = useSelector((state) => state.einSlice);

  // get login data from store
  const loginStatus = useSelector((state) => state.loginSlice);

  // get registration data from store
  const registrationSuccess = useSelector((state) => state.registerSlice);
  let getBasicInfo = registrationDetails?.registerData?.basicInformation;
  let getPartnerDetail = registrationDetails?.registerData?.partnerDetails;

  const selectedPartnerDetail = getPartnerDetail?.partnerDetails?.filter(
    (data) => {
      return data.address == getBasicInfo?.Street_Address?.value;
    }
  );

  //get Smart street data from store
  const smartSreetStoreData = useSelector((state) => state.smartStreetSlice);
  let papouSmartStreetdata = smartSreetStoreData?.smartyStreetData?.response;

  let contTex = useContext(UserContext);

  //  get preAuth data from store
  const preAuthToken = useSelector((state) => state.preAuthSlice);
  const [editableMode, setEditableMade] = useState(false);
  const [opt_in, setOpt_in] = useState(true);
  const [privacyPolicycheckbox, setPrivacyPolicyCheckbox] = useState(false);
  const [partnerFormDetails, setPartnerformDetails] = useState({
    Organization_Name: {
      value: getBasicInfo?.Organization_Name?.value,
      isValid: true,
    },
    Phone_Number: {
      value: selectedPartnerDetail[0]?.PhoneNumber,
      isValid: true,
    },
    Fax_Number: {
      value: selectedPartnerDetail[0]?.FaxNumber,
      isValid: true,
    },
    Address: {
      value: getBasicInfo?.Street_Address?.value,
      isValid: true,
    },
    City: {
      value: selectedPartnerDetail[0]?.city,
      isValid: true,
    },
    State: {
      value: selectedPartnerDetail[0]?.state,
      isValid: true,
    },
    Zip_Code: {
      value: selectedPartnerDetail[0]?.zip,
      isValid: true,
    },
    smartyStreetMatches: {
      IsValid: getBasicInfo?.IsValid || false,
      NoMatch: getBasicInfo?.NoMatch || false,
      PartialMatch: getBasicInfo?.PartialMatch || false,
      ExactMatch: getBasicInfo?.ExactMatch || false,
      SecInfoNotMatch: getBasicInfo?.SecInfoNotMatch || false,
    },
    ss_msg: getBasicInfo?.ss_msg || "",
    ss_msg_cls: getBasicInfo?.ss_msg_cls || "",
    isAppAddressValid: false,
  });

  const privacyPolicy = (e) => {
    setPrivacyPolicyCheckbox(e.target.checked);
    // if(!e.target.checked){
    //   toast.error(selectedLanguage?.policyAgreeToastMsg);
    // }
    dispatch(privacyPolicycheckboxflag(e.target.checked));
  };
  const editableModeSwitch = (e) => {
    setEditableMade(e.target.checked);
  };
  const optIn = (e) => {
    setOpt_in(e.target.checked);
  };
  function isValidatefun() {
    let isvalueNotMatch = true;
    let matchValues = registrationDetails.registerData.partnerDetails;
    let formValid =
      partnerFormDetails.Organization_Name.value != "" &&
      partnerFormDetails.Organization_Name.isValid &&
      partnerFormDetails.Phone_Number.value != "" &&
      partnerFormDetails.Phone_Number.isValid &&
      partnerFormDetails.Address.value != "" &&
      partnerFormDetails.Address.isValid &&
      partnerFormDetails.City.value != "" &&
      partnerFormDetails.City.isValid &&
      partnerFormDetails.State.value != "" &&
      partnerFormDetails.State.isValid &&
      partnerFormDetails.Zip_Code.value != "" &&
      partnerFormDetails.Zip_Code.isValid;

  if(partnerFormDetails?.Fax_Number?.value != undefined && partnerFormDetails?.Fax_Number?.value.length > 0){
    formValid = formValid && partnerFormDetails?.Fax_Number?.isValid
  }

    let tost = true;
    if (editableMode) {
      if (!formValid) {
        setEditableMade(true);
        setPartnerformDetails((prevState) => ({
          ...prevState,
          Organization_Name: {
            value: partnerFormDetails.Organization_Name.value,
            isValid:
              partnerFormDetails.Organization_Name.value != "" &&
              partnerFormDetails.Organization_Name.isValid
                ? true
                : false,
          },
          Phone_Number: {
            value: partnerFormDetails.Phone_Number.value,
            isValid:
              partnerFormDetails.Phone_Number.value != "" &&
              partnerFormDetails.Phone_Number.isValid
                ? true
                : false,
          },
          Address: {
            value: partnerFormDetails.Address.value,
            isValid:
              partnerFormDetails.Address.value != "" &&
              partnerFormDetails.Address.isValid
                ? true
                : false,
          },
          City: {
            value: partnerFormDetails.City.value,
            isValid:
              partnerFormDetails.City.value != "" &&
              partnerFormDetails.City.isValid
                ? true
                : false,
          },
          State: {
            value: partnerFormDetails.State.value,
            isValid:
              partnerFormDetails.State.value != "" &&
              partnerFormDetails.State.isValid
                ? true
                : false,
          },
          Zip_Code: {
            value: partnerFormDetails.Zip_Code.value,
            isValid:
              partnerFormDetails.Zip_Code.value != "" &&
              partnerFormDetails.Zip_Code.isValid
                ? true
                : false,
          },
        }));

        toast.error(selectedLanguage?.toastError);
      } else {
        if (
          matchValues.OrganizationName ==
            partnerFormDetails.Organization_Name.value &&
          selectedPartnerDetail[0]?.FaxNumber ==
            partnerFormDetails?.Fax_Number?.value &&
          selectedPartnerDetail[0]?.PhoneNumber ==
            partnerFormDetails.Phone_Number.value &&
          selectedPartnerDetail[0]?.state == partnerFormDetails.State.value &&
          selectedPartnerDetail[0]?.city == partnerFormDetails.City.value &&
          selectedPartnerDetail[0]?.zip == partnerFormDetails.Zip_Code.value &&
          selectedPartnerDetail[0]?.address == partnerFormDetails.Address.value
        ) {
          isvalueNotMatch = false;
        } else {
          isvalueNotMatch = true;
        }

        dispatch(contactInformationDetails(partnerFormDetails));
        let regDetails = {
          UserType: "Partner",
          EINNumber: getBasicInfo?.EIN?.value,
          FacilityPracticeName: "",
          OrganizationName: getBasicInfo?.Organization_Name?.value,
          EmailAddress: getBasicInfo?.Email_Address?.value,
          AddressLine1: partnerFormDetails?.Address?.value,
          City: partnerFormDetails.City.value,
          State: partnerFormDetails.State.value,
          ZipCode: partnerFormDetails.Zip_Code.value,
          PhoneNumber: partnerFormDetails.Phone_Number.value,
          FaxNumber: partnerFormDetails?.Fax_Number?.value,
          OptInMailSelected: opt_in,
          IsProviderUpdated: true,
          IsValid: partnerFormDetails.smartyStreetMatches.IsValid,
          NoMatch: partnerFormDetails.smartyStreetMatches.NoMatch,
          PartialMatch: partnerFormDetails.smartyStreetMatches.PartialMatch,
          ExactMatch: partnerFormDetails.smartyStreetMatches.ExactMatch,
          SecInfoNotMatch:
            partnerFormDetails.smartyStreetMatches.SecInfoNotMatch,
          AddressVerified: partnerFormDetails.isAppAddressValid,
          firstName: getBasicInfo.First_Name.value,
          lastName: getBasicInfo.Last_Name.value,
          SSVerifiedAddress: true,
          Password: getBasicInfo.password.value,
        };

        if (privacyPolicycheckbox) {
          if (isvalueNotMatch) {
            if (partnerFormDetails.ss_msg) {
              dispatch(
                registerApi({
                  BrowserId: PARTNER_BROWSER_ID.ID,
                  regDetails,
                  authorization: PARTNER_AUTH.Authorization,
                  access_token: loginStatus.access_token,
                })
              );
            } else {
              toast.error(selectedLanguage?.verifiedAddressToastMsg);
            }
          } else {
            toast.error(selectedLanguage?.matchToastError);
          }
        } else {
          toast.error(selectedLanguage?.policyAgreeToastMsg);
        }
      }
    } else {
      if (
        selectedPartnerDetail[0]?.PhoneNumber == "" ||
        selectedPartnerDetail[0]?.PhoneNumber == undefined ||
        selectedPartnerDetail[0]?.zip == "" ||
        selectedPartnerDetail[0]?.zip == undefined ||
        selectedPartnerDetail[0]?.state == "" ||
        selectedPartnerDetail[0]?.state == undefined
      ) {
        tost = false;
        formValid = false;
      } else {
        tost = true;
        formValid = true;
      }
      if (!formValid) {
        tost = true;
        setEditableMade(true);
        setPartnerformDetails((prevState) => ({
          ...prevState,
          Organization_Name: {
            value: partnerFormDetails.Organization_Name.value,
            isValid:
              partnerFormDetails.Organization_Name.value != "" ? true : false,
          },
          Phone_Number: {
            value: partnerFormDetails.Phone_Number.value,
            isValid: partnerFormDetails.Phone_Number.value != "" ? true : false,
          },
          // Fax_Number: {
          //   value: partnerFormDetails?.Fax_Number?.value,
          //   isValid: partnerFormDetails?.Fax_Number?.value != "" ? true : false,
          // },
          Address: {
            value: partnerFormDetails.Address.value,
            isValid: partnerFormDetails.Address.value != "" ? true : false,
          },
          City: {
            value: partnerFormDetails.City.value,
            isValid: partnerFormDetails.City.value != "" ? true : false,
          },
          State: {
            value: partnerFormDetails.State.value,
            isValid: partnerFormDetails.State.value != "" ? true : false,
          },
          Zip_Code: {
            value: partnerFormDetails.Zip_Code.value,
            isValid: partnerFormDetails.Zip_Code.value != "" ? true : false,
          },
        }));
        if (tost) {
          toast.error(selectedLanguage?.toastError);
        }
      } else {
        dispatch(contactInformationDetails(partnerFormDetails));
        let regDetails = {
          UserType: "Partner",
          EINNumber: getBasicInfo?.EIN?.value,
          FacilityPracticeName: "",
          OrganizationName: getBasicInfo?.Organization_Name?.value,
          EmailAddress: getBasicInfo?.Email_Address?.value,
          AddressLine1: getBasicInfo?.Street_Address?.value,
          City: selectedPartnerDetail[0]?.city,
          State: selectedPartnerDetail[0]?.state,
          ZipCode: selectedPartnerDetail[0]?.zip,
          PhoneNumber: selectedPartnerDetail[0]?.PhoneNumber,
          FaxNumber: selectedPartnerDetail[0]?.FaxNumber,
          OptInMailSelected: opt_in,
          IsProviderUpdated: false,
          IsValid: partnerFormDetails.smartyStreetMatches.IsValid,
          NoMatch: partnerFormDetails.smartyStreetMatches.NoMatch,
          PartialMatch: partnerFormDetails.smartyStreetMatches.PartialMatch,
          ExactMatch: partnerFormDetails.smartyStreetMatches.ExactMatch,
          SecInfoNotMatch:
            partnerFormDetails.smartyStreetMatches.SecInfoNotMatch,
          AddressVerified: partnerFormDetails.isAppAddressValid,
          firstName: getBasicInfo.First_Name.value,
          lastName: getBasicInfo.Last_Name.value,
          SSVerifiedAddress: true,
          Password: getBasicInfo.password.value,
        };

        if (privacyPolicycheckbox) {
          dispatch(
            registerApi({
              BrowserId: PARTNER_BROWSER_ID.ID,
              regDetails,
              authorization: PARTNER_AUTH.Authorization,
              access_token: loginStatus.access_token,
            })
          );
        } else {
          toast.error(selectedLanguage?.policyAgreeToastMsg);
        }
      }
    }
    return formValid;
  }
  contTex.formValidation.isValidate = isValidatefun;
  if (registrationSuccess?.registerData?.registrationsucces) {
    navigate("/successInformation");
    dispatch(resetregsuccess());
  }
  return (
    <>
      <div class="container">
        {" "}
        <div class="row">
          {" "}
          <div class="col-md-1"></div>
          <div class="col-md-10">
            {" "}
            <div className="pt-10">
              <Input
                type="switch"
                id="editableMode_switch"
                labelPosition="left"
                name="editable_Mode_switch"
                label={selectedLanguage?.edti}
                value={editableMode}
                onClick={(e) => editableModeSwitch(e)}
              />
            </div>
            {editableMode ? (
              <PartnerForm
                partnerFormDetails={partnerFormDetails}
                setPartnerformDetails={setPartnerformDetails}
              />
            ) : (
              <div className="container pt-10">
                <div className="row ">
                  <div className="col-md-6 text-sm-start">
                    <div>
                      <b class="fw-bold fs-base">
                        {selectedLanguage?.organizationName}{" "}
                      </b>
                      &nbsp;{" "}
                      <span>{getBasicInfo?.Organization_Name?.value}</span>
                    </div>
                    <div className="pt-2">
                      <b class="fw-bold fs-base">{selectedLanguage?.Adderss}</b>
                      <span>
                        &nbsp; {getBasicInfo?.Street_Address?.value},&nbsp;
                        {selectedPartnerDetail[0]?.city},&nbsp;
                        {selectedPartnerDetail[0]?.state},&nbsp;
                        {selectedPartnerDetail[0]?.zip}
                      </span>
                    </div>
                  </div>
                  <div className="col-md-6">
                    <div className=" row  col-md-12">
                      <div className="col-md-6"></div>
                      <div className="col-md-6 text-sm-start">
                        <div>
                          <p>
                            <b class="fw-bold fs-base">
                              {selectedLanguage?.phoneNumber}
                            </b>
                            &nbsp;
                            {selectedPartnerDetail[0]?.PhoneNumber}
                          </p>
                        </div>
                        <div>
                          <p className=" pt-2">
                            <b class="fw-bold fs-base">
                              {selectedLanguage?.fax}{" "}
                            </b>
                            &nbsp;
                            {selectedPartnerDetail[0]?.FaxNumber}
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
            <div className={`pt-8  text-sm-start ${style.optin}`}>
              <b class="fw-bold fs-base fs-sm-lg">{selectedLanguage?.optIn} </b>
            </div>
            <div className="pt-3">
              <Input
                type="switch"
                id="optIn"
                labelPosition="right"
                name="Opt_in"
                label={selectedLanguage?.optInQustion}
                onClick={(e) => optIn(e)}
                value={opt_in}
              />
            </div>
            <div className="mt-5 pt-5 fw-bolder">{selectedLanguage?.note}</div>
            <div className="d-flex justify-content-center">
              {/* <Input
                type="checkbox"
                id="policyCheckbox"
                labelPosition="left"
                name="privacy_policy_checkbox"
                label={``}
                value={editableMode}
                onClick={(e) => privacyPolicy(e)}
              /> */}
              <div className="mt-2 pt-3 d-flex justify-content-center">
                <div className="form-check form-switch d-flex justify-content-center">
                  <label className="consent-label">
                    <input
                      type="checkbox"
                      checked={privacyPolicycheckbox}
                      onClick={(e) => privacyPolicy(e)}
                      className="consent-checkbox"
                    />
                    <b className="consent-text">
                      Do you agree to our{" "}
                      <a
                        href="https://www.patientadvocate.org/terms-of-use/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="consent-link"
                      >
                        Terms of Use
                      </a>{" "}
                      and{" "}
                      <a
                        href="https://www.patientadvocate.org/privacy-policy/web-privacy-policy/"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="consent-link"
                      >
                        Privacy Policy
                      </a>
                      ?
                    </b>
                  </label>
                  {/* <label
                  className="form-check-label fw-bolder text-center"
                  style={{ width: "80%", marginLeft: "16px" }}
                  htmlFor={"policyCheckbox"}
                >
                  Do you agree to our <a  href="https://www.patientadvocate.org/privacy-policy/web-privacy-policy/" > Terms of Use </a> and <a href="https://www.patientadvocate.org/terms-of-use/">Privacy Policy</a>?
                </label>
                <input
                  onClick={(e) => privacyPolicy(e)}
                  style={{ marginLeft: "16px" }}
                  className={`form-check-input ${privacyPolicycheckbox ? "switch_input_yes" : "switch_input_no"
                    }`}
                  checked={privacyPolicycheckbox}
                  type="checkbox"
                  id="policyCheckbox"
                  name="privacy_policy_checkbox"
                  aria-label={"privacy_policy_checkbox"}
                /> */}
                </div>
              </div>
            </div>
          </div>{" "}
          <div className="col-md-1"> </div>{" "}
        </div>
      </div>
      {registrationSuccess?.registerData?.loader != undefined &&
      registrationSuccess?.registerData?.loader == true ? (
        <Loader />
      ) : null}
    </>
  );
};

export default ContactInfo;
